import React from 'react';
import { Fragment } from 'react';

const MessageBox = (props: any) => {

    let counter = 1;

    const messages = props.messages.map((message: any) => {
        const fragmentList = message.text.split(/\n/)
                .map((line: any) => <Fragment key={counter++}>{line}<br/></Fragment>);

        return { fragmentList, cssClass: getCssClass(message.type) }

    });

    return <>
              {
                  messages.map((message: any) =>
                    <div key={counter++}
                         className={"alert alert-" + message.cssClass } role="alert">
                        { message.fragmentList }
                    </div>)
              }
          </>
};

function getCssClass(type: string) {
    return type;
}

export default MessageBox;
